import { call, put, takeEvery } from 'redux-saga/effects';
import TrackingService from '../../services/TrackingService';
import {
  analyticsOverviewSuccess,
  analyticsOverviewFailure,
  analyticsOnlineSuccess,
  analyticsOnlineFailure,
  analyticsStoreSuccess,
  analyticsStoreFailure,
  analyticsOnlineDealsSuccess,
  analyticsOnlineDealsFailure,
  analyticsStoreDealsSuccess,
  analyticsStoreDealsFailure,
  analyticsFeatureMetricsSuccess,
  analyticsFeatureMetricsFailure,
} from './actions';
import {
  ANALYTICS_OVERVIEW_REQUEST,
  ANALYTICS_ONLINE_REQUEST,
  ANALYTICS_STORE_REQUEST,
  ANALYTICS_ONLINE_DEALS_REQUEST,
  ANALYTICS_STORE_DEALS_REQUEST,
  ANALYTICS_FEATURE_METRICS_REQUEST,
} from './actionTypes';

export function* getOverviewAnalytics(action) {
  try {
    const result = yield call(
      TrackingService.getOverviewAnalytics,
      action.payload,
    );
    yield put(analyticsOverviewSuccess(result));
  } catch (error) {
    yield put(analyticsOverviewFailure(error));
  }
}

export function* getOnlineAnalytics(action) {
  try {
    const result = yield call(
      TrackingService.getOnlineAnalytics,
      action.payload,
    );
    yield put(analyticsOnlineSuccess(result));
  } catch (error) {
    yield put(analyticsOnlineFailure(error));
  }
}

export function* getStoreAnalytics(action) {
  try {
    const result = yield call(
      TrackingService.getStoreAnalytics,
      action.payload,
    );
    yield put(analyticsStoreSuccess(result));
  } catch (error) {
    yield put(analyticsStoreFailure(error));
  }
}

export function* getOnlineDeals(action) {
  try {
    const result = yield call(TrackingService.getOnlineDeals, action.payload);
    yield put(analyticsOnlineDealsSuccess(result));
  } catch (error) {
    yield put(analyticsOnlineDealsFailure(error));
  }
}

export function* getStoreDeals(action) {
  try {
    const result = yield call(TrackingService.getStoreDeals, action.payload);
    yield put(analyticsStoreDealsSuccess(result));
  } catch (error) {
    yield put(analyticsStoreDealsFailure(error));
  }
}

export function* getFeatureMetrics(action) {
  try {
    const result = yield call(
      TrackingService.getFeatureMetrics,
      action.payload,
    );
    yield put(analyticsFeatureMetricsSuccess(result));
  } catch (error) {
    yield put(analyticsFeatureMetricsFailure(error));
  }
}

export function* analyticsSaga() {
  yield takeEvery(ANALYTICS_OVERVIEW_REQUEST, getOverviewAnalytics);
  yield takeEvery(ANALYTICS_ONLINE_REQUEST, getOnlineAnalytics);
  yield takeEvery(ANALYTICS_STORE_REQUEST, getStoreAnalytics);
  yield takeEvery(ANALYTICS_ONLINE_DEALS_REQUEST, getOnlineDeals);
  yield takeEvery(ANALYTICS_STORE_DEALS_REQUEST, getStoreDeals);
  yield takeEvery(ANALYTICS_FEATURE_METRICS_REQUEST, getFeatureMetrics);
}
